import {useTranslation} from 'react-i18next';
import ListWrap from '../../../../../../component/listWrap/ListWrap';
import useShow from '../../../../../../hooks/useShow';
import Input from '../../../../../../component/input/Input';
import {useLinkOptions} from '../hooks/useLinkOptions';
import {useLinkSelectState} from '../hooks/useLinkSelectState';
import {buildMenuList} from '../buildMenuList';
import * as css from '../form.css';
import {useCallback} from 'react';

interface LinkSelectProps {
    linkField: {
        value: string;
    };
    linkHelper: {
        setValue: (value: string) => void;
    };
}

function LinkSelect({linkField, linkHelper}: LinkSelectProps) {
    const {t} = useTranslation('realtime');
    const {t: layoutT} = useTranslation('layout');
    const linkListShow = useShow();
    
    const allOptions = useLinkOptions();
    const {
        isCustom,
        setForceCustom,
        showCustomInput,
        displayText
    } = useLinkSelectState({
        linkValue: linkField.value,
        allOptions
    });

    const handleSelect = useCallback((path: string) => {
        setForceCustom(false);
        linkHelper.setValue(path);
        linkListShow.close();
    }, [setForceCustom, linkHelper, linkListShow]);
    
    const handleCustomSelect = useCallback(() => {
        setForceCustom(true);
        if(!isCustom) linkHelper.setValue('');
        linkListShow.close();
    }, [setForceCustom, isCustom, linkHelper, linkListShow]);

    const menuList = buildMenuList({
        allOptions,
        handleSelect,
        handleCustomSelect,
        t,
        layoutT
    });

    return (
        <css.linkListContainer>
            <css.linkListInput onClick={linkListShow.open}>
                {displayText}
            </css.linkListInput>
            
            {linkListShow.isOpen && (
                <ListWrap
                    list={menuList}
                    onClick={undefined}
                    t={layoutT}
                    top={25} left={0} width="250px"
                    showClass={linkListShow.showClass}
                    fixedTop={undefined}
                    close={linkListShow.close}
                />
            )}

            {showCustomInput && (
                <css.customInputWrapper>
                    <Input 
                        events={{onChange: (e) => linkHelper.setValue(e.target.value)}} 
                        name="link"
                        text={t('link')}
                        description={t('linkDesc')}
                        icon={false}
                        className="link"
                        forwardRef={undefined}
                    />
                </css.customInputWrapper>
            )}
        </css.linkListContainer>
    );
}

export default LinkSelect;